export const API_BASE_URL = "https://apis-bookcms.co-trip.jp/api";
export const KEY_GITHUB = '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';
